import axios from 'axios';

export default class ServiceCallService {
  static async getServiceCalls({ model, modelId }) {
    const changeName = () => {
      let name;

      if (model === 'Contact') {
        name = 'contact_id';
      }

      if (model === 'Company') {
        name = 'company_id';
      }

      if (model !== 'Company' && model !== 'Contact') {
        name = model;
      }

      return name;
    };

    const config = {
      filters: [
        { name: 'With_site' },
        {
          name: 'Without_predefined_relations',
        },
        {
          name: changeName(),
          value: modelId,
        },
      ],
      fields: [
        'id',
        'type',
        'status',
        'scheduled',
        'title',
        'deal_type',
        'date',
        'completed_at',
        'assigned_to',
        'site',
      ],
      sortBy: 'id',
    };

    return (await axios.post('serviceCall/filter', config)).data;
  }

  static async getServiceCall(id, { signal } = {}) {
    return (await axios.get(`serviceCall/${id}`, { signal })).data;
  }

  static async getServiceCallCountBySite(siteId) {
    return (await axios.get(`serviceCall/site/count?site_id=${siteId}`)).data;
  }

  static async createServiceCall(data, { signal } = {}) {
    return (await axios.post('serviceCall/create', data, { signal })).data;
  }

  static async updateServiceCall(id, data, { signal } = {}) {
    return (await axios.put(`serviceCall/${id}`, data, { signal })).data;
  }

  static async deleteServiceCall(id) {
    return (await axios.delete(`serviceCall/${id}`)).data;
  }

  static async getTravelFee() {
    return (await axios.get('setting/client/travel_fee')).data;
  }

  static async getHourlyRate() {
    return (await axios.get('setting/client/hourly_charge')).data;
  }

  static async getTaxPreference() {
    return (await axios.get('setting/client/tax_preference')).data;
  }
}
